import { Badge } from '@/components/ui/badge';
import { formatCurrency } from '@/lib/utils/formatters';

interface PromiseTransactionBadgeProps {
  priority: number;
  promisedAmount: number;
}

export function PromiseTransactionBadge({
  priority,
  promisedAmount,
}: PromiseTransactionBadgeProps) {
  return (
    <div className="flex items-center gap-2">
      <Badge variant="secondary" className="bg-blue-100 text-blue-700 border-blue-200">
        🎯 Priority {priority}
      </Badge>
      <span className="text-sm text-muted-foreground">
        Promised: {formatCurrency(promisedAmount)}
      </span>
    </div>
  );
}
